module.exports = __webpack_public_path__ + "media/assets/images/recommendation-f5074a798a876ce8a03eb9660b3b6121.svg";